<footer>
  <div class="container-fluid" style="max-width: 1400px;">
      <div class="row">
          <div class="col-sm-12">
            <div *ngIf="showAppVersion" class="app-version">Version {{appVersion}}</div>
              <div class="rs-left-container"><p class="clamp-1" [innerHTML]="footerText | safe_html"></p></div>
              <div class="rs-right-container">
                  <ul class="span-footer-list">
                    <li>
                        <a class="terms" href="../../assets/files/Terms of Use.pdf"
                        title="Terms of Use.pdf" 
                        download="Terms of Use.pdf">Terms of Use</a>
                    </li>
                    <!-- <li><a href="#">Privacy</a></li>
                    <li><a href="#">Report a problem</a></li> -->
                  </ul>
              </div>
          </div>
      </div>
  </div>
</footer>
